import React from "react";
import img1 from "../../../Assets/ISO Certification/img1.png";
import img2 from "../../../Assets/ISO Certification/img2.png";
import img3 from "../../../Assets/ISO Certification/img3.png";

const ISOSpecification200001 = () => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 p-10">
        {/* right side content  */}
        <div className="w-full text-[#032303] font-medium sm:text-3xl md:font-medium text-md lg:text-3xl xl:text-4xl">
          <h1 className="mb-3">
            <span className="border-b-4 border-[#249742]"> ISO/IEC 200</span>
            00-1:2011 can be used by:
          </h1>

          <div className="py-4 lg:py-8 space-y-2">
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              An organization seeking services from service providers and
              requiring assurance that their service requirements will be
              fulfilled.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              An organization that requires a consistent approach by all its
              service providers, including those in a supply chain.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              A service provider that intends to demonstrate its capability for
              the design, transition, delivery and improvement of services that
              fulfil service requirements.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              A service provider to monitor, measure and review its service
              management processes and services.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              A service provider to improve the design, transition, delivery and
              improvement of services through the effective implementation and
              operation of the SMS.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              An assessor or auditor as the criteria for a conformity assessment
              of a service provider’s SMS to the requirements in ISO/IEC
              20000-1:2011.
            </p>
          </div>
        </div>

        {/* left side images  */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col items-end gap-4 justify-end w-full">
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img1} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img2} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
          </div>
          <div className="h-full">
            <img src={img3} alt="" className="rounded-lg h-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOSpecification200001;
